import React from "react";

import "./CardDetail.scss";

const CardDetail = ({
  value,
  index,
  handleChange,
  handleRemove,
  handleSelect,
  handleDisable,
  desactive,
}) => {
  let carderror = "";

  if (value.selected && value.error) {
    carderror = "merci de renseigner tous les champs";
  } else if (value.selected) {
    const errors = [value.errorName, value.errorCard, value.errorPhone].filter(
      Boolean
    );
    carderror = errors.length > 1 ? errors.join(", ") : errors[0] || "";
  }
  return (
    <div role="row" className="CardDetail">
      <div className="c">
        <div className="r">
          <div className="CardCheckbox">
            <input
              id={`${index}`}
              name={`${index}`}
              aria-checked={value.selected}
              type="checkbox"
              checked={value.selected}
              onChange={(e) => handleSelect(e, index)}
            />
            <label
              htmlFor={`${index}`}
              className={`select ${desactive ? "can" : ""}`}
            >
              <input
                type="text"
                className={`text-input left ${
                  value["errorName"] && value.selected ? "error" : ""
                }`}
                name="cardName"
                maxLength={50}
                aria-label="Nom et Prénom"
                required
                value={value.cardName}
                placeholder="Nom et Prénom"
                disabled={value.readOnly}
                onChange={(e) => {
                  return value.readOnly ? false : handleChange(e, index);
                }}
              />
              <input
                type="text"
                aria-label="CIN passport carte séjour"
                required
                className={`text-input middle ${
                  value["errorCard"] && value.selected ? "error" : ""
                }`}
                name="cardNumber"
                value={value.cardNumber}
                placeholder="CIN ou Passeport ou carte séjour"
                disabled={value.readOnly}
                onChange={(e) => {
                  return value.readOnly ? false : handleChange(e, index);
                }}
              />

              <input
                onInput={(e) => {
                  e.target.value = e.target.value.replace(
                    /[^\\+|\d]|\s|e|-|\./g,
                    ""
                  );
                  if (e.target.value.length > 9)
                    e.target.value = e.target.value.slice(0, 8);
                }}
                type="tel"
                onKeyPress={(e) => {
                  if (e.target.value.length === 9) e.preventDefault();
                }}
                aria-label="Tel"
                required
                className={`text-input right ${
                  value["error_card"] ? "error" : ""
                }`}
                name="phoneNumber"
                value={value.phoneNumber}
                placeholder="Tel"
                disabled={value.readOnly}
                onChange={(e) => {
                  return value.readOnly ? false : handleChange(e, index);
                }}
              />

              {!value.readOnly ? (
                <button
                  className="remove"
                  onClick={(e) => handleRemove(e, index)}
                >
                  {" "}
                  -{" "}
                </button>
              ) : (
                ""
              )}
            </label>
          </div>
          {value.readOnly ? (
            desactive ? (
              <div className="trash" onClick={(e) => handleDisable(e, index)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#FF3E3E"
                  viewBox="0 0 448 512"
                >
                  <path d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z" />
                </svg>
              </div>
            ) : (
              <div className="trash" onClick={(e) => handleDisable(e, index)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  fill="#FF3E3E"
                >
                  <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z" />
                </svg>
              </div>
            )
          ) : (
            <div className="empty"></div>
          )}
        </div>
        <span className="errorSpan">{carderror}</span>
      </div>
    </div>
  );
};

export default CardDetail;
